import { TypedDocumentNode, gql } from '@apollo/client';
import classNames from 'classnames';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LinkBox, LinkOverlay } from '@sorare/core/src/atoms/navigation/Box';
import { borderGradientStyle } from '@sorare/core/src/style/utils';

import { So5LeaderboardHeader } from '../So5LeaderboardHeader';
import type { So5LeaderboardWrapper_so5Leaderboard } from './__generated__/index.graphql';

const Root = styled(Vertical)`
  padding: var(--double-unit);
  border-radius: var(--double-unit);
  background: var(--c-nl-700);
  position: relative;

  button {
    text-align: left;
  }

  &.ALL_SEASONS {
    border: 1px solid var(--c-nd-100);
  }
  &.IN_SEASON {
    & > * {
      position: relative;
    }

    --border-size: 1px;
    --border-gradient: linear-gradient(
      84deg,
      #f8d3da 0%,
      #b3a9f4 28.32%,
      #fbe9fb 54.01%,
      #4f94fd 100%
    );
    ${borderGradientStyle}
  }
`;
const StyledSBHorizontal = styled(SBHorizontal)`
  flex-wrap: wrap;
`;

type Props = {
  so5Leaderboard: So5LeaderboardWrapper_so5Leaderboard;
  onClick?: () => void;
  children?: ReactNode;
  right?: ReactNode;
};

export const So5LeaderboardWrapper = ({
  so5Leaderboard,
  onClick,
  right,
  children,
}: Props) => {
  return (
    <Root as={LinkBox} className={classNames(so5Leaderboard.seasonality)}>
      <StyledSBHorizontal>
        <LinkOverlay as={ButtonBase} onClick={onClick}>
          <So5LeaderboardHeader so5Leaderboard={so5Leaderboard} />
        </LinkOverlay>
        {right}
      </StyledSBHorizontal>
      {children}
    </Root>
  );
};

So5LeaderboardWrapper.fragments = {
  so5Leaderboard: gql`
    fragment So5LeaderboardWrapper_so5Leaderboard on So5Leaderboard {
      slug
      seasonality
      ...So5LeaderboardHeader_so5Leaderboard
    }
    ${So5LeaderboardHeader.fragments.so5Leaderboard}
  ` as TypedDocumentNode<So5LeaderboardWrapper_so5Leaderboard>,
};
